export default "__VITE_ASSET__dbc1ABKD__"